const $ = window.jQuery;

// Cloak the h1 for CLS.
window.addEventListener( 'load', function() {
	$( '.iec-hero-form h1, .iec-hero.fl-row h1' ).show();
} );

// Hide the 'Request More Information' button when form does not exist
if ( ! $( '.iec-request-more-information-form' ).length ) {
	$( '.iec-mobile-top-bar' ).addClass( 'no-form' );
}
